import { useMutation, useQueryClient } from "@tanstack/react-query";
import { MARK_MESSAGE_AS_READ } from "../api/queries";
import { graphQLClient } from "../graphqlClient";

export const useMarkAllMessagesAsRead = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ messages, userID }) => {
      if (!messages || messages.length === 0) {
        throw new Error("No messages to mark as read.");
      }

      const contractTTL = Math.floor(Date.now() / 1000); // Current timestamp in seconds

      await Promise.all(
        messages.map((message) =>
          graphQLClient.request(MARK_MESSAGE_AS_READ, {
            messageID: message.id,
            userID,
            path: message.path,
            contractTTL,
          }),
        ),
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["messages"] });
    },
    onError: (error) => {
      console.error("❌ Error marking messages as read:", error);
    },
  });
};
